import { Spacing8 } from 'autogen/design-tokens/tokens';
import Bullet from 'components/Bullet/Bullet';
import { Typography } from 'components/generic/typography';
import type { IBody } from 'components/generic/typography/components/Body';
import type { PropsWithChildren } from 'react';
import styled from 'styled-components';

export type BulletItemProps = PropsWithChildren &
    IBody & {
        bulletRenderer?: () => JSX.Element;
    };

const BulletItemContainer = styled(Typography.Body).attrs({ as: 'li' })`
    display: flex;
    margin: 0;
    line-height: 1.5;
`;

const StyledBullet = styled(Bullet)`
    margin-top: ${Spacing8};
    margin-right: ${Spacing8};
    background-color: ${({ theme }) => theme.ColorIconPrimary};
`;

function DefaultBullet() {
    return <StyledBullet />;
}

function BulletItem(props: BulletItemProps) {
    const { children, bulletRenderer = DefaultBullet, ...restProps } = props;

    return (
        <BulletItemContainer size="S" {...restProps}>
            {bulletRenderer()}
            <span>{children}</span>
        </BulletItemContainer>
    );
}

export default BulletItem;
